module.exports = __webpack_public_path__ + "img/twitter-icon.ca5ca79e.svg";